var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoanBook = function SvgLoanBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 88 67"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loan-book_svg__a)",
    d: "M13.396 0h-.007c-.828 0-1.607.323-2.196.91a3.12 3.12 0 0 0-.922 2.224v46.99a3.144 3.144 0 0 0 3.138 3.133c7.294.017 19.514 1.537 27.945 10.36V14.44c0-.584-.15-1.133-.431-1.587C34.003 1.71 20.707.018 13.396 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loan-book_svg__b)",
    d: "M77.301 50.124V3.134c0-.841-.327-1.631-.922-2.224A3.1 3.1 0 0 0 74.184 0h-.008C66.866.017 53.57 1.71 46.65 12.854a3 3 0 0 0-.43 1.587v49.175c8.43-8.822 20.65-10.342 27.945-10.36a3.144 3.144 0 0 0 3.137-3.132"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loan-book_svg__c)",
    d: "M84.439 10.837h-2.272v39.287c0 4.4-3.585 7.987-7.991 7.998-6.187.014-16.389 1.224-23.614 8.062 12.496-3.06 25.668-1.07 33.175.64a3.13 3.13 0 0 0 2.657-.605 3.12 3.12 0 0 0 1.178-2.448v-49.8a3.137 3.137 0 0 0-3.133-3.134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loan-book_svg__d)",
    d: "M5.405 50.124V10.837H3.133A3.137 3.137 0 0 0 0 13.97v49.8c0 .959.43 1.85 1.178 2.448.75.598 1.718.82 2.657.606 7.507-1.712 20.68-3.7 33.174-.64-7.224-6.838-17.426-8.048-23.613-8.062-4.406-.011-7.99-3.599-7.99-7.998"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M62.837 38.47c-1.642 0-3.019-.377-4.13-1.14a7.15 7.15 0 0 1-2.521-3.052c-.567-1.275-.833-2.686-.833-4.244 0-1.63.266-3.104.81-4.41a6.73 6.73 0 0 1 2.533-3.095c1.145-.763 2.591-1.139 4.35-1.139a8.5 8.5 0 0 1 3.967.972l-.416 2.645a8.7 8.7 0 0 0-1.735-.69 7 7 0 0 0-1.874-.251c-1.597 0-2.823.512-3.656 1.536s-1.26 2.457-1.26 4.286c0 1.787.404 3.22 1.203 4.306.798 1.087 2.012 1.62 3.655 1.62.67 0 1.319-.083 1.943-.271a8.3 8.3 0 0 0 1.759-.742l.358 2.414c-.393.314-.971.596-1.735.857a7.1 7.1 0 0 1-2.418.397"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M64.669 27.6H52.248v1.864h12.42zM64.669 30.706H52.248v1.863h12.42z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loan-book_svg__a",
    x1: 25.812,
    x2: 25.812,
    y1: 0,
    y2: 63.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loan-book_svg__b",
    x1: 61.76,
    x2: 61.76,
    y1: 0,
    y2: 63.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loan-book_svg__c",
    x1: 69.067,
    x2: 69.067,
    y1: 10.837,
    y2: 66.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "loan-book_svg__d",
    x1: 18.505,
    x2: 18.505,
    y1: 10.837,
    y2: 66.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B06"
  })))));
};
export default SvgLoanBook;